<template>
	<div class="grid-content">
		<div class="grid-content-title">
			<div class="name">支付记录</div>
			<div class="right">
				<el-button size="mini" @click="refreshPay">
					<i class="el-icon-refresh"></i>
					<span>刷新</span>
				</el-button>
			</div>
		</div>
		<div class="grid-content-search">
			<div class="line">
				<el-row :gutter="20">
					<el-col :span="9">
						<div class="box">
							<div class="label">支付查询：</div>
							<div class="input">
								<el-input v-model="query.keyword" placeholder="请输入关键字" class="input-with-select"
									size="small">
									<el-select v-model="query.type" slot="prepend" placeholder="请选择">
										<el-option label="按昵称" value="nick"></el-option>
										<el-option label="按ID" value="id"></el-option>
										<el-option label="按手机号" value="phone"></el-option>
									</el-select>
								</el-input>
							</div>
						</div>
					</el-col>
					<el-col :span="15">
						<el-button type="primary" icon="el-icon-search" size="small" style="width: 6rem;">搜索
						</el-button>
						<el-button size="small" @click="query = {}">重置</el-button>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="grid-content-list paylog">
			<div class="common-table">
				<table class="header">
					<colgroup>
						<col width="4%">
						<col>
						<col width="15%">
						<col width="11%">
						<col width="11%">
						<col width="15%">
						<col width="15%">
					</colgroup>
					<thead>
						<tr>
							<th>
								<el-checkbox></el-checkbox>
							</th>
							<th>支付编号</th>
							<th>订单编号</th>
							<th>实付金额</th>
							<th>状态</th>
							<th>付款时间</th>
							<th>创建时间</th>
						</tr>
					</thead>
				</table>
				<table class="body" v-loading="(loading && total>0)?true:false">
					<colgroup>
						<col width="4%">
						<col>
						<col width="15%">
						<col width="11%">
						<col width="11%">
						<col width="15%">
						<col width="15%">
					</colgroup>
					<thead>
						<template v-for="(item,index) in list">
							<tr class="separation-row">
								<td colspan="7"></td>
							</tr>
							<tr class="content-row">
								<td>
									<div style="display: flex;align-items: center;justify-content: center;">
										<el-checkbox></el-checkbox>
									</div>
								</td>
								<td>
									<div class="pay-no">
										<span v-if="item.pay_type == 'NATIVE'">[扫码支付]</span>
										<span v-if="item.pay_type == 'DRIVER_HAND'">[线下支付]</span>
										<span v-if="item.pay_type == 'WEAPP_JSAPI'">[小程序支付]</span>
										<span v-if="item.pay_type == 'JSAPI'">[H5支付]</span>
										<span style="margin-left: 0.3125rem;">{{item.pay_no}}</span>
										<template v-if="item.pay_time">
											<el-popover
												v-if="item.pay_type == 'NATIVE' || item.pay_type == 'WEAPP_JSAPI'"
												placement="top" title="微信支付单号" trigger="click" :content="item.pay_nos">
												<i class="el-icon-s-comment"
													style="margin-left: 0.3125rem;cursor: pointer;"
													slot="reference"></i>
											</el-popover>
										</template>
									</div>
								</td>
								<td>
									<div class="order-no">
										{{item.order_no}}
									</div>
								</td>
								<td>
									<div class="amount">{{item.pay_amount}}</div>
								</td>
								<td>
									<div class="status">-</div>
								</td>
								<td>
									<div class="time">{{item.pay_time}}</div>
								</td>
								<td>
									<div class="time">{{item.create_time}}</div>
								</td>
							</tr>
						</template>
					</thead>
				</table>
			</div>
			<div v-if="loading && total<=0" style="min-height: 20rem;" v-loading="loading"></div>
			<div v-if="total>0" class="page">
				<el-pagination background layout="total, prev, pager, next" :current-page.sync="page" :total="total"
					@current-change="pagePay">
				</el-pagination>
			</div>
			<el-empty v-if="!loading && total<=0" style="height: 20rem;" description="暂无支付数据" :image-size="100">
			</el-empty>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
				query: {},
				page: 1,
				total: 0,
				list: []
			};
		},
		created() {
			this.postPay();
		},
		methods: {
			refreshPay() {

			},
			pagePay(e) {
				this.page = e;
				this.postPay();
			},
			postPay() {
				const that = this;
				that.loading = true;
				that.$post('orderPaylog', {
					page: that.page
				}).then(res => {
					setTimeout(function() {
						that.loading = false;
						that.total = res.data.total;
						res.data.list.map((item) => {
							item.checked = false;
							return item;
						});
						that.list = res.data.list;
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.paylog .common-table {
		font-size: 0.875rem;
	}

	.paylog .common-table .pay-no {
		padding: 0.625rem;
	}

	.paylog .common-table .order-no,
	.paylog .common-table .amount,
	.paylog .common-table .order-no,
	.paylog .common-table .time {
		text-align: center;
	}
</style>
